export default __webpack_public_path__ + "static/media/gallery_05.85862a11.jpg";